import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import RealAffordability from "@/pages/tools/RealAffordability";

export const Route = createFileRoute("/tools/real-affordability")({
  head: () => seoHead("/tools/real-affordability"),
  component: RealAffordability,
});
